declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_bidi_in_dictionary_foo extends $mol_object {
		run( next?: any ): any
		event( ): ({ 
			click( next?: ReturnType< $mol_view_tree2_to_js_test_ex_bidi_in_dictionary_foo['run'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_bidi_in_dictionary_foo['run'] >,
		}) 
	}
	
}

//# sourceMappingURL=bidi_in_dictionary.view.tree.d.ts.map